module.exports = __webpack_public_path__ + "media/images/icons/marker-3d70ac6e0d33fbdd07b85720dd411b21.svg";